import React from 'react';
import Commons from 'js/helpers/Commons';
import environments from 'js/constants/environments';

const getStoredConfigFromLocalStorage = () => {
    try {
        const cruxLocalStorage = window.localStorage;
        const cruxStore = JSON.parse(cruxLocalStorage.getItem('persist:crux'));
        return JSON.parse(cruxStore?.config || '{}');
    } catch (e) {
        return null;
    }
}

export const getAssetDomainOld = (fileName = '') => {
    // change if necessary
    const assetDomain = 'https://d3ihm20vnhytj4.cloudfront.net/crux';
    try {
        const environment = Commons.get(getStoredConfigFromLocalStorage(), 'appenv.env');
        switch (environment) {
            case environments.UAT:
                return `${assetDomain}/uat/crux_assets/${fileName}`;
            case environments.PRODUCTION:
                return `${assetDomain}/prod/crux_assets/${fileName}`;
            default:
                return `${assetDomain}/dev/crux_assets/${fileName}`;
        }
    } catch (e) {
        return `${assetDomain}/prod/crux_assets/${fileName}`;
    }
};

// Created a new function to get assets from new MCOM s3
// This is to avoid breaking changes to existing assets
export const getAssetDomain  = (pathFromAsset = '') => {
    const assetDomain = getStoredConfigFromLocalStorage()?.applicationDomain?.assetCdn
        || 'https://crux-assets.corelogic.asia';
    const assetPath = '/assets/ui';

    return `${assetDomain}${assetPath}${pathFromAsset}`;
};

export const LOGOS = {
    RP_HEADER: getAssetDomain('/logos/rp-header.svg'),
    PG_HEADER: getAssetDomain('/logos/pg-header.svg'),
    COTALITY: getAssetDomain('/logos/cotality-logo.svg'),
    FAVICON: getAssetDomain('/logos/favicon.png'),
    COTALITY_ICON: getAssetDomain('/logos/cotality-icon-dark.png'),
}

export const COMPLIANCE_NOTES_AU = 'Marketing_Direct_Compliance_AU.txt';
export const COMPLIANCE_NOTES_NZ = 'Marketing_Direct_Compliance_NZ.txt';

const ATTRIBUTES = {
    BEDS: <img src={getAssetDomainOld('bed@2x.png')} className="half-opacity" alt="Bedrooms" width="27px" />,
    BATHS: <img src={getAssetDomainOld('bathroom@2x.png')} className="half-opacity" alt="Bathrooms" width="27px" />,
    CARS: <img src={getAssetDomainOld('car@2x.png')} className="half-opacity" alt="Car Spaces" width="30px" />,
    LANDSIZE: <img src={getAssetDomainOld('land@2x.png')} className="half-opacity" alt="Land Size" width="26px" />,
};

const ATTRIBUTES_MIN = {
    BEDS: <img src={getAssetDomainOld('bed@2x.png')} className="half-opacity" alt="Bedrooms" width="22px" />,
    BATHS: <img src={getAssetDomainOld('bathroom@2x.png')} className="half-opacity" alt="Bathrooms" width="22px" />,
    CARS: <img src={getAssetDomainOld('car@2x.png')} className="half-opacity" alt="Car Spaces" width="25px" />,
    LANDSIZE: <img src={getAssetDomainOld('land@2x.png')} className="half-opacity" alt="Land Size" width="21px" />,
};

export default {
    ATTRIBUTES,
    ATTRIBUTES_MIN,
};
